<div class="flex items-center p-3">
    <span class="dark:text-white leading-7">
      <span *ngIf="questionNumber" class="rtl:ml-1 ltr:mr-1">
        {{questionNumber.toString()|convertToPersian}}.
      </span>
      {{data.text}}
      <span class="rtl:mr-1 ltr:ml-1 text-sm font-normal">
          (حداقل گزینه انتخابی : {{data.additional_fields.minimum_answer.toString()|convertToPersian}})
      </span>
    </span>
    <button *ngIf="config.number_of_permitted_vague_question>0 || config.is_can_comment_on_question" (click)="changeCommentState()" class="rtl:mr-2 ltr:ml-2 flex items-center justify-center h-full aspect-square">
        <mat-icon class="mat-center">
            edit_note
        </mat-icon>
    </button>
</div>
<app-expand-sec (dataEmitter)="updateExpandSecData($event)" (commentEmitter)="sendComment()" [showFormObs]="commentStatusObs$" [config]="{isShowUnknown: config.number_of_permitted_vague_question>0, isShowComment: config.is_can_comment_on_question, questionId: data.id, isUnknownInitalValue: isUnknownInital}"></app-expand-sec>
<form [formGroup]="formGroup" class="flex flex-col p-3 font-normal rounded-lg transition-all ease-in-out duration-300 relative" [style]="getErrorStyle()">
    <div *ngFor="let o of data.options;let i = index;" class="my-1 rounded-md bg-lightCardBG dark:bg-darkCardBG border border-lightMode-300 dark:border-darkMode-700 cursor-pointer ease-in-out duration-150" [style]="getFormControlValue(i)?activeOptionStyle:hoverNum==i?hoverOptionStyle:{}">
        <input [id]="'option-'+o.id" type="checkbox" [formControlName]="i" class="hidden">
        <label [for]="'option-'+o.id" class="w-full flex justify-between items-center py-2 px-3 cursor-pointer">
            <span>
                {{o.additional_fields.text}}
            </span>
            <span class="w-5 aspect-square flex items-center justify-center overflow-hidden" [class]="getFormControlValue(i)?'':'hidden'">
                <mat-icon class="mat-center text-green-500">
                    done
                </mat-icon>
            </span>
        </label>
    </div>
    <app-hatch-skin *ngIf="extraData.isUnknown" @hatchFade></app-hatch-skin>
</form>